import TableHeaderNavigationButton from "./TableHeaderNavigationButton";

type Props = {
  selected: number;
  total: number;
  onClick: (next: number) => void;
};

const TableHeaderNavigation = ({ selected, total, onClick }: Props) => {
  const handleClick = (next: number) => {
    if (next < 0 || next > total - 1) return;
    onClick(next);
  };

  const current = selected + 1;

  return (
    <div className="flex align-center flex-gap-3">
      <TableHeaderNavigationButton
        data-testid="table_header_back_button"
        disabled={selected === 0}
        icon="chevron-left"
        onClick={() => handleClick(selected - 1)}
      />
      <div className="flex align-center flex-gap-1">
        <span className="fs-lg">{current}</span>{" "}
        <span className="fs-md font-normal">of {total}</span>
      </div>
      <TableHeaderNavigationButton
        data-testid="table_header_forward_button"
        disabled={selected === total - 1}
        icon="chevron-right"
        onClick={() => handleClick(selected + 1)}
      />
    </div>
  );
};

export default TableHeaderNavigation;
